export enum CourseEnum {
  FIRST_COURSE = "first-course",
  SECOND_COURSE = "second-course",
}
